import {Component, Input, OnInit} from '@angular/core';
import {Sterownik} from 'design-system';
import { takeUntil } from 'rxjs/operators';
import { DestroyComponent } from 'src/app/components/destroy/destroy.component';
import { DateHelper } from 'src/app/helpers/dateHelper';
import { DataFilterZdarzeniaService } from 'src/app/services/data-filter-zdarzenia.service';
import { NewsletterService } from 'src/app/services/newsletter.service';
import {Zdarzenie} from '../../../models/zdarzenie.model';

@Component({
  selector: 'app-zdarzenia-tabela',
  templateUrl: './zdarzenia-tabela.component.html',
  styleUrls: ['./zdarzenia-tabela.component.scss']
})
export class ZdarzeniaTabelaComponent extends DestroyComponent implements OnInit {

  @Input() tabelaAktualne: Zdarzenie[];
  @Input() tabelaWczesniejsze: Zdarzenie[];
  @Input() pokazTabeleWczesniejsze: boolean;
  loadingAktualne: boolean;
  loadingWczesniejsze: boolean;
  sterownik: Sterownik;
  sterownikWczesniejsze: Sterownik;
  formatDate = DateHelper.FORMAT_DATE;
  dataUdostepnienia: string = '';
  loading = false;

  constructor(
    private newsletterService: NewsletterService,
    private dataFilterService: DataFilterZdarzeniaService
    ) {
    super();
   }

  ngOnInit(): void {
    this.initSterownik();
    this.initSterownikWczesniejsze();
    this.initDataUdostepnienia();
  }

  initSterownik(): void {
    this.sterownik = {
      key: '',
      name: 'newsLetterEvents',
      stateStorage: 'session',
      columns: [
        {header: 'Data zdarzenia', field: 'dataZdarzenia', dataType: 'string', sortable: true},
        {header: 'Sygnatura', field: 'sygnatura', dataType: 'string', sortable: true},
        {header: 'Typ zdarzenia', field: 'zdarzenie', dataType: 'string', sortable: true},
        {header: 'Numer wpisu', field: 'numerWpisu', dataType: 'string', sortable: true},
      ],
      paginator: {
        rowsPerPageOptions: [10, 20, 50],
        rows: 10,
      } ,
      sort: {
        field: 'dataZdarzenia',
        order: -1
      }
    };

    this.dataFilterService.loading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.loadingAktualne = value ;
      });
  }

  initSterownikWczesniejsze(): void {
    this.sterownikWczesniejsze = {
      key: '',
      name: 'newsLetterEarlierEvents',
      stateStorage: 'session',
      columns: [
        {header: 'Data zdarzenia', field: 'dataZdarzenia', dataType: 'string', sortable: true},
        {header: 'Sygnatura', field: 'sygnatura', dataType: 'string', sortable: true},
        {header: 'Typ zdarzenia', field: 'zdarzenie', dataType: 'string', sortable: true},
        {header: 'Numer wpisu', field: 'numerWpisu', dataType: 'string', sortable: true},
      ],
      paginator: {
        rowsPerPageOptions: [10, 20, 50],
        rows: 10,
      } ,
      sort: {
        field: 'dataZdarzenia',
        order: -1
      }
    };

    this.dataFilterService.loadingWczesniejszeZdarzenia$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.loadingWczesniejsze = value;
      });
  }

  private initDataUdostepnienia() {
    this.newsletterService.konfiguracja$
      .pipe(takeUntil(this.destroy$))
      .subscribe(val => {
        this.dataUdostepnienia = val?.dataUdostepnienia;
      });
  }
}
